import { render } from "./AdminNavbar.vue?vue&type=template&id=27b1afe0&scoped=true"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=27b1afe0&scoped=true&lang=scss"
import "./AdminNavbar.vue?vue&type=style&index=1&id=27b1afe0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b1afe0"]])

export default __exports__